import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderEntity, DataProviderType } from '../../../utils/request';
import {
  FeatureManagerEndpointMethod,
  GetCompanyFeaturesPayload,
  PackagesEndpointMethod,
} from '../../packagesGrid/types';
import { PackageData } from '../../types/package-data';
import { Feature } from '@nirvana/shared/constants';
import { CreatePackageResponse } from '../../types/types';
import { UpdatePackageResponse } from '../../types/types';
import { GetCompanyFeaturesResponse } from '../../../utils/response';

export class PackagePanelBaseDataProvider extends BaseWebComponentDataProvider {
  private endpoint = 'Packages';
  private featuresEndpoint = 'FeaturesManager';

  public async addPackage(payload: PackageData): Promise<CreatePackageResponse> {
    let response;
    try {
      response = await ConsoleRequest.createRequest<CreatePackageResponse>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: this.endpoint,
        method: PackagesEndpointMethod.CREATE_RECORDS,
        payload: { records: [payload], default: false },
      });
    } catch (e) {
      console.error(e);
    }

    if (!response || !response.success) {
      return { success: false };
    }

    return response;
  }

  public async updatePackage(payload: PackageData): Promise<UpdatePackageResponse> {
    let response;
    try {
      response = await ConsoleRequest.createRequest<UpdatePackageResponse>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: this.endpoint,
        method: PackagesEndpointMethod.UPDATE_RECORDS,
        payload: { records: [payload], default: false },
      });
    } catch (e) {
      console.error(e);
    }

    if (!response || !response.success) {
      return { success: false };
    }

    return response;
  }

  public async getFeaturesByCompany(payload: GetCompanyFeaturesPayload): Promise<Feature[]> {
    let response;

    try {
      response = await ConsoleRequest.createRequest<GetCompanyFeaturesResponse>({
        dataProviderType: DataProviderType.CORE,
        dataProviderEntity: DataProviderEntity.SYSTEM,
        endpoint: this.featuresEndpoint,
        method: FeatureManagerEndpointMethod.GET_FEATURES_BY_COMPANY,
        payload: payload,
      });
    } catch (e) {
      return [];
    }

    return response.features;
  }
}
